<template>
  <div class="servicios-refugio">
    <h5 v-if="typeTable=='primary'">{{nameRef}} - {{roomName}}</h5>
    <table class="table table-responsive-sm col-12 table-servicios">
      <thead>
      <tr>
        <th class="text-left">{{idioma.fecha}}</th>
        <th class="text-center" v-for="(srv,idxS) in getServices" :key="srv.idService">{{srv.nombre}}</th>
        <th class="text-center" v-if="typeTable=='primary'">{{idioma.pernocta}}</th>
      </tr>
      </thead>
      <tbody>
      <ServiceRow v-for="(dia,idxDia) in dates"
                  :bookingId="bookingId"
                  :key="dia"
                  :services="getServicesDate(dia)"
                  :order="idxDia"
                  :last="idxDia == dates.length-1"
                  :pernocta="typeTable=='primary'"
                  :table="typeTable"
                  :day="dia"/>
      </tbody>
    </table>
  </div>
</template>

<script>

  import ServiceRow from "./ServiceRow";
  export default {
    name: "ServiceTable",
    components: {ServiceRow},
    props: ['bookingId', 'idioma', 'services','idRef', 'nameRef', 'idRoom', 'roomName', 'typeTable'],
    data(){
      return {
        localServices:[],
        dates:[]
      }
    },

    created() {
      // Formateo de los servicios para que sea mas facil trabajar
      this.formatServices(this.services)
      // Obtengo las fechas de los servicios
      this.allServicesDates()
    },

    filters:{
      dateToEs(_date){
        return _date.split('-').reverse().join('/')
      }
    },
    computed:{
      getServices(){
        return this.localServices
      }
    },
    methods:{
      /**
       *
       * @param {array} data Array of services
       * @param {boolean} typeService Type of services in data. TRUE->Standard FALSE->Extra
       */
      formatServices(data){
        for(let key in data){
          if(!data.hasOwnProperty(key)) continue
          let _service = data[key]
          _service['idService'] = key
          this.localServices.push(_service)
        }
      },
      allServicesDates(){
        this.localServices.forEach((_service) => {
          _service.fechas.forEach((_date)=>{
            if(!this.dates.includes(_date))
              this.dates.push(_date)
          })
        })
      },
      getServicesDate(_cur){
        return this.localServices.filter((_srv) => {
          return _srv.fechas.includes(_cur)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/services/ServiceTable.vue